import { Component, Input } from '@angular/core';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';
import { PlIcon } from '@app/icon-library/icons';

export interface ButtonConfig {
  variant: ButtonVariant;
  label: string;
  iconLeft?: PlIcon;
  isDisabled?: boolean;
  action?: () => any | Promise<any>;
}

@Component({
  selector: 'pl-bottom-navigation',
  templateUrl: './bottomNavigation.component.html',
})
export class BottomNavigationComponent {
  @Input({ required: true }) public buttonLeft: ButtonConfig | null = null;
  @Input({ required: true }) public buttonRight: ButtonConfig | null = null;

  public readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;
  public readonly PlIcon: typeof PlIcon = PlIcon;

  public onButtonClicked(buttonConfig: ButtonConfig): void {
    if (buttonConfig && typeof buttonConfig.action === 'function') {
      buttonConfig.action();
    }
  }
}
